var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 0C18.6277 0 24 5.373 24 12C24 18.6271 18.6277 24 12 24C5.37217 24 0 18.627 0 12C0 5.37308 5.37225 0 12 0Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.76203 16.488H9.00905V8.99847H6.76203V16.488ZM15.5161 8.73904C14.4255 8.73904 13.4498 9.13728 12.7576 10.0163V8.97383H10.5023V16.4881H12.7576V12.4246C12.7576 11.5658 13.5444 10.728 14.5298 10.728C15.5153 10.728 15.7584 11.5658 15.7584 12.4036V16.4873H18.0054V12.2363C18.0053 9.28352 16.6073 8.73904 15.5161 8.73904ZM7.87503 8.25001C8.49604 8.25001 9.00007 7.74598 9.00007 7.12498C9.00007 6.50397 8.49604 6.00002 7.87503 6.00002C7.25402 6.00002 6.75 6.50405 6.75 7.12506C6.75 7.74607 7.25402 8.25001 7.87503 8.25001Z",
    fill: "#F0DE00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.311dd50c4c86ffa91854acdf4b71b169.svg";
export { ForwardRef as ReactComponent };